import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

export function CartBadge({ totalItems }) {
  return (
    <Link to="/cart" data-testid="nav-cart" className="relative p-2 hover:bg-muted rounded-lg transition-colors">
      <ShoppingCart className="w-5 h-5 text-foreground" />
      {totalItems > 0 && (
        <span data-testid="cart-badge" className="absolute -top-0.5 -right-0.5 w-5 h-5 text-[10px] bg-accent text-accent-foreground rounded-full flex items-center justify-center font-bold">{totalItems}</span>
      )}
    </Link>
  );
}

export function LanguageSwitcher({ locale, setLocale, locales, onSelect }) {
  return (
    <div className="flex items-center gap-1 text-xs">
      {locales.map((l, i) => (
        <span key={l} className="flex items-center gap-1">
          <button
            data-testid={`lang-${l}`}
            onClick={() => { setLocale(l); onSelect?.(); }}
            className={`uppercase font-semibold transition-colors hover:text-primary ${locale === l ? 'text-primary' : 'text-muted-foreground'}`}
          >
            {l}
          </button>
          {i < locales.length - 1 && <span className="text-border">|</span>}
        </span>
      ))}
    </div>
  );
}

export function AuthMenu({ user, logout, t }) {
  if (user) {
    return (
      <div className="flex items-center gap-3">
        <Link to="/account" data-testid="nav-account" className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors">
          {t.nav.myAccount}
        </Link>
        <button data-testid="logout-btn" onClick={logout} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors">
          {t.nav.logout}
        </button>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3">
      <Link to="/login" data-testid="login-link" className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors">{t.nav.login}</Link>
      <Link to="/register" data-testid="register-link" className="bg-primary text-primary-foreground rounded-full px-5 py-2 text-sm font-medium hover:bg-primary/90 transition-all active:scale-95">{t.nav.register}</Link>
    </div>
  );
}
